import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";
import { BackEndPlatformTypes } from "types";
import {
	alphaNumericNormalizer,
	maxLength50,
	normalizeAll,
	onlyAlphanumericAndSpecialCharacters,
	onlyMaxAlphaNumeric7,
	onlyMaxAlphaNumeric8,
	required,
	trimNormalizer,
	trimMidSentenceNormalizer,
} from "validators";

import styles from "../terminalSolution.module.scss";

type OtherFileBuildProps = {
	sectionName?: string;
	isLoading?: boolean;
};

const OtherFileBuild = ({
	sectionName = "fileBuild",
	isLoading = false,
}: OtherFileBuildProps) => {
	const { register, watch } = useFormContext();

	const backEndPlatform = watch("backEndPlatform");

	const isBackEndPlatformOtherOrTsys = [
		BackEndPlatformTypes.Other.name,
		BackEndPlatformTypes.Tsys.name,
	].includes(backEndPlatform);

	return (
		<div className={styles.section} data-autotest="fileBuildInfoSection">
			<Row className="form-group">
				<Col md={5} data-autotest="fileTypeColumn">
					<HookFormInputGroup
						name={`${sectionName}.fileType`}
						register={register}
						label="File Type"
						colInput={6}
						colLabel={6}
						blurLoading={isLoading}
						autoComplete="off"
						normalizeOnBlur={trimNormalizer}
						normalize={normalizeAll([
							onlyAlphanumericAndSpecialCharacters,
							trimMidSentenceNormalizer,
						])}
						validator={{ required, maxLength50 }}
						showRequiredMark
					/>
				</Col>
				{!isBackEndPlatformOtherOrTsys && (
					<Col
						md={{ span: 5, offset: 2 }}
						data-autotest="datawireIdColumn"
					>
						<HookFormInputGroup
							name={`${sectionName}.datawireId`}
							register={register}
							label="Datawire ID"
							colInput={6}
							colLabel={6}
							blurLoading={isLoading}
							autoComplete="off"
							normalizeOnBlur={trimNormalizer}
							normalize={normalizeAll([
								onlyMaxAlphaNumeric8,
								alphaNumericNormalizer,
							])}
						/>
					</Col>
				)}
			</Row>
			{!isBackEndPlatformOtherOrTsys && (
				<Row className="form-group">
					<Col md={5} data-autotest="dlidColumn">
						<HookFormInputGroup
							name={`${sectionName}.dlid`}
							register={register}
							label="DLID"
							colInput={6}
							colLabel={6}
							blurLoading={isLoading}
							autoComplete="off"
							normalizeOnBlur={trimNormalizer}
							normalize={normalizeAll([
								onlyMaxAlphaNumeric7,
								alphaNumericNormalizer,
							])}
						/>
					</Col>
				</Row>
			)}
		</div>
	);
};

export default OtherFileBuild;
